import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=04421c4b&scoped=true"
import script from "./UserSelect.vue?vue&type=script&lang=js"
export * from "./UserSelect.vue?vue&type=script&lang=js"
import style0 from "./UserSelect.vue?vue&type=style&index=0&id=04421c4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04421c4b",
  null
  
)

export default component.exports